import { TapResponse } from '@iotize/tap';
import { TapStreamWriter } from '@iotize/tap/client/impl';
import { tapnpassConverters } from '@iotize/tap/service/impl/tapnpass';
import {
  TargetCanProtocolConfiguration,
  targetConverters,
} from '@iotize/tap/service/impl/target';
import { SlaveServerRawConfig } from './generated/models';
import { SlaveServerService as SlaveServerServiceBase } from './generated/service';
import {
  ModbusRtuProtocolConfiguration,
  SlaveServerModbusTcpConfiguration,
} from './models-custom';

export class SlaveServerServiceExtended extends SlaveServerServiceBase {
  public putCanProtocolConfiguration(
    canConfig: TargetCanProtocolConfiguration,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putCanProtocolConfigurationCall(canConfig),
    );
  }

  public putCanProtocolConfigurationCall(
    config: TargetCanProtocolConfiguration,
  ) {
    const canConfigEncoded =
      targetConverters.targetCanProtocolConfiguration.encode(config);
    return this.putProtocolConfigurationCall({
      channel: SlaveServerRawConfig.Channel.CAN,
      config: canConfigEncoded,
      length: canConfigEncoded.length,
    });
  }

  public putSpiProtocolConfiguration(): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putSpiProtocolConfigurationCall(),
    );
  }

  public putSpiProtocolConfigurationCall() {
    return this.putProtocolConfigurationCall({
      channel: SlaveServerRawConfig.Channel.SPI,
      config: new Uint8Array(0),
      length: 1,
    });
  }

  public putModbusRtuProtocolConfiguration(
    config: ModbusRtuProtocolConfiguration,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putModbusRtuProtocolConfigurationCall(config),
    );
  }

  public putModbusRtuProtocolConfigurationCall(
    tapnpassConfigApi: ModbusRtuProtocolConfiguration,
  ) {
    const modbusConfigEncoded: Uint8Array =
      tapnpassConverters.tapnpassProtocolConfiguration.encode(
        tapnpassConfigApi,
      );
    return this.putProtocolConfigurationCall({
      channel: SlaveServerRawConfig.Channel.MODBUS_RTU,
      config: modbusConfigEncoded,
      length: modbusConfigEncoded.length,
    });
  }

  public putModbusTcpProtocolConfiguration(
    config: SlaveServerModbusTcpConfiguration,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putModbusTcpProtocolConfigurationCall(config),
    );
  }

  public putModbusTcpProtocolConfigurationCall(
    config: SlaveServerModbusTcpConfiguration,
  ) {
    const modbusTcpConfigEncoded: Uint8Array = new TapStreamWriter(5)
      .writeU1(config.firstRegisterAddress || 0)
      .writeU4(config.port).toBytes;

    return this.putProtocolConfigurationCall({
      channel: SlaveServerRawConfig.Channel.MODBUS_TCP,
      config: modbusTcpConfigEncoded,
      length: modbusTcpConfigEncoded.length,
    });
  }
}
